import type { FieldValues, UseFormReturn } from 'react-hook-form';

import React from 'react';

import { PASSWORD_MESSAGES } from './constants';
import { Typography } from '../../atoms/Typography';
import { Icon } from '../../atoms/icons';
import { Button } from '../../molecules/buttons';
import { Form } from '../Form';

type PasswordFormProps<TFieldValues extends FieldValues> = {
  handleSubmit: () => void;
  title: string;
  instruction: string;
  showPasswordInstruction?: boolean;
  passwordInstruction?: string;
  buttonText: React.ReactNode;
  loading?: boolean;
  methods: UseFormReturn<TFieldValues>;
};

const PasswordForm = <TFieldValues extends FieldValues>({
  handleSubmit,
  title,
  passwordInstruction = PASSWORD_MESSAGES.PASSWORD_INSTRUCTION,
  buttonText,
  loading = false,
  methods
}: PasswordFormProps<TFieldValues>) => (
  <>
    <div className={'flex flex-col items-center justify-center mb-8'}>
      <Typography className={'mb-2'} fontFace={'BodyRegularLg'}>
        {title}
      </Typography>
    </div>
    <Form methods={methods}>
      <Form.Item name={'password'}>
        <Form.Label colon={false}>{'Create a New Password'}</Form.Label>
        <Form.Input type={'password'} />
        <Form.Error />
      </Form.Item>

      <div className={'flex flex-col gap-1 mb-6'}>
        {passwordInstruction.split('.').map((item, index) => (
          <Typography
            key={index}
            className={'flex items-center gap-1 text-gray-600'}
            fontFace={'BodyRegularLg'}
          >
            <Icon iconName={'iconDiamond'} width={12} height={12} /> {item}
          </Typography>
        ))}
      </div>
      <Form.Item name={'confirmPassword'}>
        <Form.Label colon={false}>{'Confirm Password'}</Form.Label>
        <Form.Input type={'password'} />
        <Form.Error />
      </Form.Item>
    </Form>

    <Button
      buttonType={'brand'}
      isFullWidth
      className={'mt-6'}
      onClick={methods.handleSubmit(handleSubmit)}
      loading={loading}
    >
      {buttonText}
    </Button>
  </>
);

export { PasswordForm };
export type { PasswordFormProps };
